// src/AnimationContext.ts
import { createContext, useContext } from 'react';

// 默认值为 true，这样如果没有包裹 AnimatedPage 的普通组件也能正常加载
export const AnimationContext = createContext<boolean>(true);

// 自定义 Hook，方便组件调用
export const usePageAnimation = () => useContext(AnimationContext);